import {TypeOfItem} from "../types";
import React from "react";
import {BaseItemCol} from "./base_items/BaseItemCol";
import {BaseItem} from "./base_items/BaseItem";
import {BaseItemRow} from "./base_items/BaseItemRow";
import {BaseItemSquare} from "./base_items/BaseItemSquare";
import {BaseItemAngle} from "./base_items/BaseItemAngle";
import {Bomb} from "./base_items/Bomb";

export const renderItems = (item: TypeOfItem, isDrag: boolean, PANEL_SIZE_ITEM: number, SIZE: number) => {
    const SIZE_ITEM = !isDrag ? PANEL_SIZE_ITEM : SIZE;
    const ITEMS_RENDER: {[key in TypeOfItem]: React.ReactNode} = {
        BOMB: <Bomb size={SIZE_ITEM} />,

        SINGLE: <BaseItem isDrag={isDrag} size={SIZE_ITEM} typeOfItem={item} />,

        DOUBLE_COL: <BaseItemCol isDrag={isDrag} count={2} size={SIZE_ITEM} component={BaseItem} typeOfItem={item} />,
        TRIPLE_COL: <BaseItemCol isDrag={isDrag} count={3} size={SIZE_ITEM} component={BaseItem} typeOfItem={item} />,
        FOUR_COL: <BaseItemCol isDrag={isDrag} count={4} size={SIZE_ITEM} component={BaseItem} typeOfItem={item} />,
        FIVE_COL: <BaseItemCol isDrag={isDrag} count={5} size={SIZE_ITEM} component={BaseItem} typeOfItem={item} />,

        DOUBLE_ROW: <BaseItemRow isDrag={isDrag} count={2} size={SIZE_ITEM} component={BaseItem} typeOfItem={item} />,
        TRIPLE_ROW: <BaseItemRow isDrag={isDrag} count={3} size={SIZE_ITEM} component={BaseItem} typeOfItem={item} />,
        FOUR_ROW: <BaseItemRow isDrag={isDrag} count={4} size={SIZE_ITEM} component={BaseItem} typeOfItem={item} />,
        FIVE_ROW: <BaseItemRow isDrag={isDrag} count={5} size={SIZE_ITEM} component={BaseItem} typeOfItem={item} />,

        DOUBLE_SQUARE: <BaseItemSquare isDrag={isDrag} size={SIZE_ITEM} count={4} component={BaseItem} typeOfItem={item} />,
        TRIPLE_SQUARE: <BaseItemSquare isDrag={isDrag} square={3} size={SIZE_ITEM} count={9} component={BaseItem} typeOfItem={item} />,

        MINI_ANGLE_LEFT_TOP: <BaseItemAngle isDrag={isDrag} size={SIZE_ITEM} count={3} component={BaseItem} type='MINI_ANGLE_LEFT_TOP' />,
        MINI_ANGLE_RIGHT_TOP: <BaseItemAngle isDrag={isDrag} size={SIZE_ITEM} count={3} component={BaseItem} type='MINI_ANGLE_RIGHT_TOP' />,
        MINI_ANGLE_RIGHT_BOTTOM: <BaseItemAngle isDrag={isDrag} size={SIZE_ITEM} count={3} component={BaseItem} type='MINI_ANGLE_RIGHT_BOTTOM' />,
        MINI_ANGLE_LEFT_BOTTOM: <BaseItemAngle isDrag={isDrag} size={SIZE_ITEM} count={3} component={BaseItem} type='MINI_ANGLE_LEFT_BOTTOM' />,

        ANGLE_LEFT_TOP: <BaseItemAngle isDrag={isDrag} size={SIZE_ITEM} count={5} component={BaseItem} type='ANGLE_LEFT_TOP' />,
        ANGLE_LEFT_BOTTOM: <BaseItemAngle isDrag={isDrag} size={SIZE_ITEM} count={5} component={BaseItem} type='ANGLE_LEFT_BOTTOM' />,
        ANGLE_RIGHT_BOTTOM: <BaseItemAngle isDrag={isDrag} size={SIZE_ITEM} count={5} component={BaseItem} type='ANGLE_RIGHT_BOTTOM' />,
        ANGLE_RIGHT_TOP: <BaseItemAngle isDrag={isDrag} size={SIZE_ITEM} count={5} component={BaseItem} type='ANGLE_RIGHT_TOP' />,
    }

    return ITEMS_RENDER[item];
}
